import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '../components/ui/button';
import { ArrowLeft, RotateCcw } from 'lucide-react';
import WordCloud from '../components/slides/activity/WordCloud';
import type { Slide } from '../../utils/supabase/client';

export default function DemoWordCloud() {
  const navigate = useNavigate();
  const [key, setKey] = useState(0);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  // Demo slide data
  const demoSlide: Slide = {
    id: 'demo-word-cloud',
    lesson_id: 'demo',
    type: 'word_cloud',
    slide_order: 0,
    created_at: new Date().toISOString(),
    content: {
      title: 'Word Cloud',
      question: 'What words come to mind when you think of photosynthesis?',
      prompt: 'Share your thoughts about photosynthesis',
    },
  };

  const handleSubmit = (answer: any) => {
    setHasSubmitted(true);
    console.log('Word cloud submitted:', answer);
  };

  const handleAnswerChange = (_answer: any) => {
    // Words are tracked internally by the component
  };

  const handleRestart = () => {
    setHasSubmitted(false);
    setKey(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-background to-blue-50 dark:from-indigo-950/20 dark:via-background dark:to-blue-950/20">
      {/* Header */}
      <header className="border-b border-border bg-card/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Button variant="ghost" onClick={() => navigate('/demos')}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Demos
            </Button>
            <Button variant="outline" onClick={handleRestart}>
              <RotateCcw className="w-4 h-4 mr-2" />
              Reset
            </Button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">Word Cloud Demo</h1>
          <p className="text-muted-foreground text-sm md:text-base">
            Submit words and watch the cloud grow! Perfect for brainstorming and gathering class input.
          </p>
        </div>

        <WordCloud
          key={key}
          slide={demoSlide}
          onSubmit={handleSubmit}
          onAnswerChange={handleAnswerChange}
          selectedAnswer={null}
          hasSubmitted={hasSubmitted}
        />
      </div>
    </div>
  );
}
